import GoogleTagManager from "./googleTagManager";
import SentryClass from "./sentry";

export { AmplitudeTracker, PaltaDataPlatformTracker } from "./amplidute";
export const TagManager = new GoogleTagManager();
export const Sentry = new SentryClass();
